<form
  #userForm="ngForm"
  [formGroup]="userDetailsForm"
  (ngSubmit)="submit(userForm)"
>
  <div class="inline-questions">
    <div
      class="intercom-container"
      [attr.data-intercom-target]="
        intercomLabels.USER_ADD_EDIT_MODAL_FIRST_NAME
      "
    >
      <emperor-text-input
        formControlName="firstName"
        label="First name"
        [isReadOnly]="isReadonly"
        [inputId]="existingUser?.id ?? 'first-field'"
      ></emperor-text-input>
    </div>
    <div
      class="intercom-container"
      [attr.data-intercom-target]="intercomLabels.USER_ADD_EDIT_MODAL_LAST_NAME"
    >
      <emperor-text-input
        formControlName="lastName"
        label="Last name"
        [isReadOnly]="isReadonly"
      ></emperor-text-input>
    </div>
  </div>
  <div
    class="intercom-container"
    [attr.data-intercom-target]="intercomLabels.USER_ADD_EDIT_MODAL_EMAIL"
  >
    <emperor-text-input
      formControlName="email"
      label="Email address"
      type="email"
      [errorMessageMap]="{
        required: 'This field is required',
        email: 'Please enter a valid email address',
        groupEmail:
          'Carriers usually won\'t accept group emails. Please provide a different email.',
      }"
      [isReadOnly]="isReadonly"
    ></emperor-text-input>
    <emperor-text-input
      *ngIf="!isReadonly"
      formControlName="emailConfirmation"
      label="Confirm email"
      type="email"
      [errorMessageMap]="{
        required: 'This field is required',
        matches: 'Those emails don\'t match. Try again.',
      }"
    ></emperor-text-input>
  </div>
  <div class="inline-questions">
    <div
      class="intercom-container"
      [attr.data-intercom-target]="intercomLabels.USER_ADD_EDIT_MODAL_PHONE"
    >
      <emperor-masked-input
        formControlName="phone"
        label="Phone number"
        [mask]="phoneMask"
        [isReadOnly]="isReadonly"
      ></emperor-masked-input>
    </div>
    <div
      class="intercom-container"
      [attr.data-intercom-target]="
        intercomLabels.USER_ADD_EDIT_MODAL_ACCOUNT_TYPE
      "
    >
      <emperor-select
        formControlName="role"
        label="Account type"
        [choices]="emperorUserGroups"
        [isReadOnly]="
          isReadonly || (currentUserId$ | async) === existingUser?.id
        "
      ></emperor-select>
    </div>
  </div>
  <div
    *ngIf="shouldCollectUserNpn$ | async"
    class="intercom-container"
    [attr.data-intercom-target]="intercomLabels.USER_ADD_EDIT_MODAL_NPN"
  >
    <app-npn-input
      label="Agent's National Producer Number (NPN)"
      [npnControl]="userDetailsForm.controls.npn"
      [isReadOnly]="isReadonly"
      [isOptional]="true"
    ></app-npn-input>
  </div>

  <div *ngIf="!isReadonly" class="button-container">
    <emperor-button
      *ngIf="
        !!existingUser &&
        !isUserDeactivated &&
        (currentUserId$ | async) !== existingUser.id
      "
      emperorDialogClose
      [uiButtonType]="EmperorUIButtonTypes.Text"
      [color]="EmperorThemeColor.WARN"
      class="text-uppercase deactivate-button"
      (click)="deactivateUser(existingUser)"
    >
      Deactivate user
    </emperor-button>

    <emperor-button
      *ngIf="showClearButton"
      [uiButtonType]="EmperorUIButtonTypes.Text"
      class="text-uppercase"
      (click)="clearForm()"
    >
      Clear
    </emperor-button>

    <div
      class="intercom-container submit-btn"
      [attr.data-intercom-target]="intercomLabels.USER_ADD_EDIT_MODAL_CTA"
    >
      <emperor-button
        *ngIf="userDetailsForm"
        [uiButtonType]="EmperorUIButtonTypes.Standard"
        [color]="EmperorThemeColor.PRIMARY"
        class="text-uppercase"
        type="submit"
      >
        {{ submitButtonText }}
      </emperor-button>
    </div>
  </div>
</form>
